import React from 'react';
import { useDentoData } from '../context/DentoContext';

export const ClinicGallery = () => {
    const { galleryImages } = useDentoData();
    const gallery = galleryImages || [];

    return (
        <section id="gallery" className="py-16 md:py-24 bg-gray-50 overflow-hidden">
            <div className="container mx-auto px-4">
                <div className="text-center mb-10 md:mb-16">
                    <h2 className="text-3xl md:text-5xl font-extrabold text-black mb-4 font-heading tracking-tight">
                        Our Clinic
                    </h2>
                    <div className="w-16 h-1.5 bg-black mx-auto rounded-full"></div>
                    <p className="text-black/60 mt-6 max-w-2xl mx-auto text-base md:text-lg leading-relaxed font-body">
                        Take a virtual tour of our state-of-the-art dental clinic designed for your comfort and premium care.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {gallery.map((item) => (
                        <div
                            key={item.id}
                            className="relative rounded-[24px] md:rounded-[32px] overflow-hidden shadow-xl h-64 md:h-80"
                        >
                            <img
                                src={item.image}
                                alt={item.title}
                                className="w-full h-full object-cover"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
